import './ModalExistek.less';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';

const ModalExistek = ({ children, className, onCancel, footer, disabled = false, ...props }) => {
    return (
        <Modal
            {...props}
            keyboard={true}
            maskClosable={true}
            closable={false}
            className={'modal ' + className}
            destroyOnHidden={true}
            okButtonProps={{ disabled }}
            footer={(_, { OkBtn }) => {
                return footer === undefined ? (
                    <>
                        <Button type="text" danger onClick={onCancel}>
                            Cancel
                        </Button>
                        <OkBtn />
                    </>
                ) : (
                    footer
                );
            }}
        >
            {children}
        </Modal>
    );
};

ModalExistek.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    okText: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    footer: PropTypes.node,
};
export default ModalExistek;
